import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";

import "./helper.css";

export interface AsideModalProps extends React.HTMLAttributes<HTMLDivElement> {
    /**
     * Flag to show or hide modal.
     */
    showModal: boolean;
    /**
     * Content to render inside the card.
     * The content will be any React nodes passed as children.
     */
    children: React.ReactNode; // React.ReactNode es un tipo adecuado para los children
    /**
     * The position to place the Modal
     */
    location: "top" | "left" | "right" | "bottom" | "center" | "static";
    /**
     * optional heigt proerty.
     */
    navbarHeight?: string;
}

const AsideModalComponent: React.FC<AsideModalProps> = ({ showModal, children, location, navbarHeight = "60px" }) => {
    const [isVisible, setIsVisible] = useState(showModal);
    const [isClosing, setIsClosing] = useState(false);

    useEffect(() => {
        if (showModal) {
            setIsVisible(true);
        } else {
            setIsClosing(true);
            setTimeout(() => {
                setIsClosing(false);
                setIsVisible(false);
            }, 1000);        // the anumation duration must be the same in CSS animation
        }
    }, [showModal]);

    const getModalStyles = () => {
        switch (location) {
            case "left":
                return {
                    top: navbarHeight,
                    left: 0,
                    width: "20%",
                    height: `calc(100% - ${navbarHeight})`,
                };
            case "right":
                return {
                    top: navbarHeight,
                    right: 0,
                    /*
                        En una ventana angosta, 648px fijos dejaban el panel pegado a los dos
                        bordes y el texto arrancaba justo en el filo. Con min() se queda en
                        648 cuando hay sitio y ocupa el ancho disponible cuando no.
                        (Esteban, 2026-09-21)
                    */
                    width: "min(648px, 100vw)",
                    height: `calc(100% - ${navbarHeight})`,
                };
            case "top":
                return {
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "20%",
                };
            case "bottom":
                return {
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "20%",
                };
            case "center":
                return {
                    top: `calc(50% + ${parseInt(navbarHeight) / 2}px)`,
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "min(648px, 100vw)",
                    height: "auto",
                };
            case "static":
                return {
                    position: "static",
                    width: "min(648px, 100%)",
                    height: "auto",
                };
            default:
                return {};
        }
    };

    if (!isVisible) return null;

    return (
        <div
            style={{
                ...getModalStyles(),
                background: "var(--wa-superficie)",
                overflowY: "auto",
                position: location !== "static" ? "fixed" : "static",
                zIndex: 1,
            }}
            className={`${isClosing ? 'slide-out-right' : 'slide-in-right'}`}
        >
            <Box
                style={{
                    width: "100%",
                    height: "100%",
                }}
                sx={{ boxShadow: 2 }}
                role="presentation"
            >
                <div
                    className="card waPanelLateral"
                    style={{
                        width: "100%",
                        height: "100%",
                        overflowY: "auto",
                        paddingBottom: "25px",
                    }}
                >
                    {children}
                </div>
            </Box>
        </div>
    );
};

export default AsideModalComponent;